
import Player from "@vimeo/player/dist/player.es";
import $ from "jquery";
export default class VimeoWrapper {
    initPlayer(options) {
        this.videoUrl = options.videoUrl.replace(/[\u200B-\u200D\uFEFF]/g, '');
        this.metaEndpoint = 'https://vimeo.com/api/oembed.json';
        this.player = new Player(options.videoNode, {id: options.videoId});


        this.player.ready().then(() => {
            options.onReadyCallback();
        });

        this.player.on('play', () => {
            options.onPlayCallback();
        });
    }

    play() {
        this.player.play();
    }
    stop() {
        this.player.pause();
    }
    async getDuration() {
        const videoUrl = encodeURIComponent(this.videoUrl);
        const request = `${this.metaEndpoint}?url=${videoUrl}`;
        const result = await $.get( request);
        return result.duration;
    }

}



// WEBPACK FOOTER //
// ./components/responsive-video/scripts/players/vimeo-wrapper.js